import { AppAction } from '../../../../state/app';
import { SampleDevelopmentHlApprovalRequest } from '../../../../state/sampleDevelopmentHlApprovalRequest/sampleDevelopmentHlApprovalRequest.types';
import { FAILURE, REQUEST, SUCCESS } from '../../../../utils/actionTypeUtil';
import { FETCH_PENDING_APPROVAL_SAMPLE_DEV_HL_LIST } from './pendingApprovalSampleDevHlRequestList.actions';

export interface PendingApprovalSampleDevHlRequestListState {
  loading: boolean;
  items: ReadonlyArray<SampleDevelopmentHlApprovalRequest>;
  errorMessage: string;
  totalItems: number;
}

const initialState: PendingApprovalSampleDevHlRequestListState = {
  errorMessage: '',
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: PendingApprovalSampleDevHlRequestListState = initialState,
  action: AppAction,
): PendingApprovalSampleDevHlRequestListState => {
  switch (action.type) {
    case REQUEST(FETCH_PENDING_APPROVAL_SAMPLE_DEV_HL_LIST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PENDING_APPROVAL_SAMPLE_DEV_HL_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PENDING_APPROVAL_SAMPLE_DEV_HL_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    default:
      return state;
  }
};
